module.exports = __webpack_public_path__ + "img/family-hero-banner.648d4d79.png";